/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { INITIAL_PAGE_SORTING_AND_FILTERING } from 'pages/userTable/components/useUserTable';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  selectDeleteButton,
  selectDialog,
  selectStatus,
  selectUserIds,
  toggleDeleteButton,
  toggleDialog,
} from './users.remove.slice';
import { removeUsersFromOrg } from './users.remove.thunk';
import { fetchUsers } from '../paginate/users.thunk';

export default function useRemoveUsersFromOrg(orgId) {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const removeDialog = useSelector(selectDialog);
  const userIds = useSelector(selectUserIds);
  const deleteButton = useSelector(selectDeleteButton);

  const onToggleRemoveDialog = open => dispatch(toggleDialog(open));
  const updateUserIds = newUserIds => dispatch(updateUserIds(newUserIds));
  const onToggleDeleteButton = visible => dispatch(toggleDeleteButton(visible));

  useEffect(() => {
    if (status === ThunkStatus.SUCCEEDED) {
      dispatch(
        fetchUsers({
          organizationId: orgId,
          pagingSortingAndFiltering: INITIAL_PAGE_SORTING_AND_FILTERING,
        }),
      );
    }

    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onRemoveUsersConfirm = () => {
    dispatch(removeUsersFromOrg({ orgId, userIds }));
  };

  return {
    isLoading,
    removeDialog,
    userIds,
    deleteButton,
    updateUserIds,
    onRemoveUsersConfirm,
    onToggleRemoveDialog,
    onToggleDeleteButton,
  };
}
